<template>
<div>
  <v-toolbar flat class="pa-3">
    <v-text-field
      label="Buscar"
      append-icon="search"
      v-model="activeFilters.search"
      />
  </v-toolbar>
  <data-table
    :total="totalResults"
    :items="measurements"
    :headers="headers"
    :loading="loading"
    :row-action="toDetailRoute"
    :page="currentPage"
    @paginationUpdated=paginationUpdated
    >
    <template slot="row" slot-scope="row" >
      <td>{{ row.item.code }}</td>
      <td>{{ row.item.start | format-date-time }}</td>
      <td>{{ row.item.end |format-date-time }}</td>
      <td>{{ row.item.device.code  }}</td>
      <td>{{ row.item.material.code }}</td>
      <td align="right">
        <span v-if="row.item.weight">{{ row.item.weight }} <sub>t</sub></span>
      </td>
      <td align="right">
        <span v-if="row.item.speed">{{ row.item.speed }} <sub>t/hora</sub></span>
      </td>
    </template>
  </data-table>
</div>
</template>

<script>
import _ from 'lodash'

import api from '@/api/app'
import DataTable from '@/components/DataTable'
import urlParamsMixin from '@/mixins/urlParamsMixin'

export default {
  name: 'MeasurementList',
  mixins: [urlParamsMixin],
  components: {DataTable},
  mounted () {
    this.loading = true
    this.getMeasurements()
  },
  data () {
    return {
      loading: false,
      headers: [
        {
          text: 'Código',
          align: 'left',
          sortable: true,
          value: 'code'
        },
        {
          text: 'Comienzo',
          align: 'left',
          sortable: true,
          value: 'start'
        },
        {
          text: 'Fin',
          align: 'left',
          sortable: true,
          value: 'end'
        },
        {
          text: 'Dispositivo',
          align: 'left',
          sortable: true,
          value: 'device'
        },
        {
          text: 'Materia Prima',
          align: 'left',
          sortable: true,
          value: 'material'
        },
        {
          text: 'Peso total',
          align: 'right',
          sortable: true,
          value: 'weight'
        },
        {
          text: 'Velocidad',
          align: 'right',
          sortable: true,
          value: 'speed'
        }
      ],
      date: Date(),
      measurements: [],
      pagination: {},
      activeFilters: {},
      params: {},
      currentPage: null,
      totalResults: 0
    }
  },
  methods: {
    setURLQueryParams () {
      Object.assign(this.params, this.activeFilters, this.pagination)
      Object.keys(this.params).forEach(key => {
        if (!this.params[key]) { delete this.params[key] }
      })
      this.$router.replace({ name: this.$route.name, query: this.params })
    },
    paginationUpdated (pagination) {
      this.pagination = pagination
      this.currentPage = this.pagination.page
      this.setURLQueryParams()
      this.getMeasurements()
    },
    toDetailRoute (id) {
      this.$router.push({name: 'measurement-detail', params: {'id': id}})
    },
    getMeasurements: _.debounce(function () {
      api.getMeasurements(_.merge(this.params, {measurement_type: 'full'})).then(response => {
        this.measurements = response.results
        this.totalResults = response.count
        this.loading = false
      })
    }, 400)
  },
  watch: {
    activeFilters: {
      handler () {
        if (this.loading) { return }

        this.currentPage = 1
        this.setURLQueryParams()
        this.getMeasurements()
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/MeasurementList.vue